export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14751.6a0dd8a1.jpg";